<template>
  <div>
    <form class="form-horizontal">
      <div class="answer-contianer ts-overflow-x-hidden ts-mb-4">
        <ts-card-wrapper style="background-color: #f2f3f4;">
          <div class="row" v-for="(chunk, index) in answerChunks" :key="index">
            <div
              class="col-sm-12 col-lg-6 col-md-6"
              v-for="(answer, key) in chunk"
              :key="key"
            >
              <div class="form-group">
                <div class="ts-space-x-2">
                  {{ $t('eschool.pair') }}
                  <label class="ts-inline-block ts-font-bold">{{
                    answer.answer_prefix
                  }}</label>
                </div>
                <ckeditor
                  :editor="editor"
                  v-model="answer.answers"
                  :config="editorConfig"
                ></ckeditor>
                <div
                  class="validate"
                  v-if="
                    errors.has('answer_list.' + (answer.id - 1) + '.answers')
                  "
                >
                  {{
                    errors.first('answer_list.' + (answer.id - 1) + '.answers')
                  }}
                </div>
                <div class="input-group ts-mt-1">
                  <span class="input-group-text">{{
                    $t('question.answer')
                  }}</span>
                  <input
                    type="text"
                    class="form-control"
                    v-model="answer.answer"
                  />
                </div>
                <div
                  class="validate"
                  v-if="
                    errors.has('answer_list.' + (answer.id - 1) + '.answer')
                  "
                >
                  {{
                    errors.first('answer_list.' + (answer.id - 1) + '.answer')
                  }}
                </div>
                <a
                  v-if="answer.id > min_answer_choice"
                  href="#"
                  class="ts-font-bold text-danger"
                  @click.prevent="removeAnswer(answer)"
                  >{{ $t('eschool.remove') }}</a
                >
              </div>
            </div>
          </div>
          <div class="row" v-if="model.answer_list.length <= 25">
            <div class="col-lg-12">
              <a
                href="#"
                class="ts-font-bold text-primary"
                @click.prevent="addAnswer"
                ><i class="fas fa-plus"></i> {{ $t('eschool.addNewChoice') }}</a
              >
            </div>
          </div>
        </ts-card-wrapper>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
Vue.use(CKEditor)

export default {
  name: 'dragAndMatch',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      selected: null,
      min_answer_choice: 4,
      answer_prefix: [],
      new_answer: {
        question_id: 0,
        answer_id: 0,
        answers: '',
        answer: '',
        answer_prefix: '',
        is_correct: false,
        is_describe: false
      },
      editor: ClassicEditor,
      editorConfig: {
        // Editor configuration
        toolbar: [
          'bold',
          'italic',
          '|',
          'mathType',
          'ChemType',
          'bulletedList',
          'numberedList',
          '|',
          'alignment',
          'outdent',
          'indent',
          'blockQuote',
          'insertTable',
          'undo',
          'redo'
        ]
      }
    }
  },
  created() {
    this.model = this.value
    this.defaultAnswer()
  },
  computed: {
    ...mapState('eschool/eExam/question', ['letter', 'number', 'roman_number']),
    answerChunks() {
      return _.chunk(Object.values(this.model.answer_list), 2)
    }
  },
  methods: {
    defaultAnswer() {
      this.model.answer_list = []
      for (let i = 1; i <= this.min_answer_choice; i++) {
        this.model.answer_list.push(
          Object.assign({}, this.new_answer, {
            id: i,
            answer_prefix: this.answer_prefix[i - 1]
          })
        )
      }
    },
    removeAnswer(answer) {
      this.model.answer_list.splice(this.model.answer_list.indexOf(answer), 1)
      this.model.answer_list.map((item, index) => {
        ;(item.id = index + 1), (item.answer_prefix = this.answer_prefix[index])
      })
    },
    addAnswer() {
      this.model.answer_list.push(_.clone(this.new_answer))

      this.model.answer_list.map((item, index) => {
        ;(item.id = index + 1), (item.answer_prefix = this.answer_prefix[index])
      })
    },
    changeAnswerPrefix() {
      this.model.answer_list.map((item, index) => {
        item.answer_prefix = this.answer_prefix[index]
      })
    }
  },
  watch: {
    'model.answer_option_id': function(val) {
      if (val == 1) {
        this.answer_prefix = this.letter
      }
      if (val == 2) {
        this.answer_prefix = this.number
      }
      if (val == 3) {
        this.answer_prefix = this.roman_number
      }
      this.changeAnswerPrefix()
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.answer-contianer {
  max-height: 40vh;
}
</style>
